import { Link } from '@mui/material';
import React from 'react';

const DataGridContactEmail = ({ email }) => {
	return email ? (
		<Link
			href={`mailto:${email}`}
			underline='hover'
			sx={{
				cursor: 'pointer',
				color: 'inherit',
				'&:hover': {
					color: 'primary.main',
				},
			}}
			onClick={(e) => e.stopPropagation()}
		>
			{email}
		</Link>
	) : (
		<></>
	);
};

export default DataGridContactEmail;
